export const ensureValue = <T>(
  value: T | undefined | null,
  name?: string,
): T => {
  if (value === undefined || value === null) {
    const prefix = name ? `Value for "${name}"` : "Value";
    throw new Error(`${prefix} is required but is unavailable`);
  }
  return value;
};

export const ensureError = (e: unknown): Error => {
  if (e instanceof Error) {
    return e;
  }
  if (typeof e === "string") {
    return new Error(e);
  }
  return new Error("Unknown error");
};

export const isNotNullOrUndefined = <T>(x: T): x is NonNullable<T> =>
  x !== null && x !== undefined;
